import Swiper, { Pagination, Manipulation } from "swiper";
import { initIntersectionObserver } from "@plugins";

const upsellSlider = document.querySelector(".js-upsell-slider");

if (window.mobileMedia && upsellSlider) {
    initIntersectionObserver(upsellSlider, initUpsellSlider);
}

function initUpsellSlider(slider) {
    const swiper = new Swiper(slider, {
        modules: [Pagination, Manipulation],
        speed: 400,
        slidesPerView: 1.35,
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        preventClicks: false,
        breakpoints: {
            375: {
                slidesPerView: 1.65,
            },
            390: {
                slidesPerView: 1.75,
            },
            500: {
                slidesPerView: "auto",
            },
        },
        pagination: {
            el: ".js-upsell-controls > .swiper-pagination",
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
            type: "progressbar",
        },
    });

    const loadMoreLink = slider.querySelector(".js-more-upsells-link");

    if (loadMoreLink) {
        loadMoreLink.classList.add("swiper-slide");
        swiper.appendSlide(loadMoreLink);
    }
}
